import { useObjectMarkerLocalizer } from '../../ObjectMarker';
import { getIconAndLabelTextFromType } from '../../ObjectMarker/__internal__/getIconAndLabelTextFromType';
export const useTileStatus = props => {
  const objectMarkerLocalize = useObjectMarkerLocalizer();
  const objectMarkers = [];
  if (props.favorited) {
    objectMarkers.push({
      type: 'Favorite'
    });
  }
  if (props.objectMarkers) {
    objectMarkers.push(...props.objectMarkers);
  }
  const statuses = [];
  for (const {
    type
  } of objectMarkers) {
    const {
      labelText
    } = getIconAndLabelTextFromType(type, objectMarkerLocalize);
    statuses.push(labelText);
  }
  return statuses.join(', ');
};
//# sourceMappingURL=useTileStatus.js.map